<script>
import getAutoInput from './autoinput';

export default {
  name: 'FieldItem',
  functional: true,
  props: {
    value: {
      type: [Number, String, Array, Object],
      default: '',
    },
    query: {
      type: Object,
      default: () => {},
    },
  },
  render(h, context) {
    // 设置组件
    const AUTOINPUT = getAutoInput(h, context);

    // 获取组件
    const inputEl = AUTOINPUT();

    return inputEl;
  },
};
</script>
